<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Generate PRN From Form No.</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br />
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="3">
          <v-select
            rounded
            :items="aylist"
            label="Academic Year"
            item-text="academicyear"
            item-value="ay_id"
            outlined
            dense
            v-model="ay"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            rounded
            label="Enter Form No."
            @click="applicationForm_data = []"
            class="padding-bot"
            outlined
            dense
            v-model="form_no"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-btn
            class="mt-2 button"
            v-if="form_no"
            small
            :loading="loader"
            @click="getFormDetails()"
            >Proceed</v-btn
          >
        </v-col>
        <v-col
          cols="12"
          sm="1"
          md="1"
          v-if="all_app_form_data != '' && form_no"
        >
          <v-tooltip top color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="50"
                v-bind="attrs"
                v-on="on"
                color="red"
                @click="dialog = true"
                >mdi-filter</v-icon
              >
            </template>
            <span> See All Apllication Forms </span>
          </v-tooltip>
        </v-col>
      </v-row>
      <span v-if="applicationForm_data != ''">
        <v-row dense justify="center">
          <v-col cols="12" sm="3" md="3"
            ><strong>Form No. :: </strong
            >{{ applicationForm_data[0].display_admission_form_no }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Admission Year :: </strong
            >{{ applicationForm_data[0].admissionyear }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Form Date :: </strong
            >{{ applicationForm_data[0].application_date }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Name :: </strong>{{ applicationForm_data[0].name }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Standard :: </strong
            >{{ applicationForm_data[0].standard }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Email :: </strong
            >{{ applicationForm_data[0].personal_email }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Mobile No. :: </strong
            >{{ applicationForm_data[0].mobile_no }}</v-col
          >
          <v-col cols="12" sm="3" md="3"
            ><strong>Form Status :: </strong
            >{{ applicationForm_data[0].applicationstatus }}</v-col
          >
        </v-row>
        <v-row class="toolbar" dense justify="center">
          <strong>
            Next PRN Generated Will Be : {{ this.serial_track }}
          </strong>
        </v-row>
        <v-row justify="center" dense>
          <v-btn
            class="button"
            :disabled="applicationForm_data[0].applicationstatus != 'Confirmed'"
            @click="save()"
            :loading="loader1"
            >Generate PRN</v-btn
          >
        </v-row>
      </span>
      <v-dialog v-model="dialog" persistent max-width="1200px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> All Application Forms </strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12">
            <center>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-data-table
                v-if="all_app_form_data.length > 0"
                :headers="headers1"
                :items="all_app_form_data"
                :search="search"
                dense
                class="elevation-1 mytable"
              >
              </v-data-table>
            </center>
          </v-col>
          <v-row justify="center">
            <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    registration_no: "",
    aylist: [],
    ay: "",
    form_no: null,
    loader: false,
    applicationForm_data: [],
    all_app_form_data: [],
    dialog: false,
    serial_track: null,
    loader1: false,
    headers1: [
      {
        text: "Sr. No.",
        value: "srno",
      },
      {
        text: "Form No.",
        align: "center",
        value: "display_admission_form_no",
      },
      {
        text: "Admission Year",
        align: "center",
        value: "admissionyear",
      },
      {
        text: "Form Status",
        align: "center",
        value: "applicationstatus",
      },
      {
        text: "Student Name",
        align: "center",
        value: "name",
      },
      {
        text: "Form Date",
        align: "center",
        value: "application_date",
      },
    ],
  }),
  methods: {
    getFormDetails() {
      const data = {
        ay: this.ay,
        form_no: this.form_no,
      };
      axios
        .post("AdmissionForm/getFormDetails", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.smsg);
            this.onload();
            this.loader1 = false;
            return;
          }
          if (res.data.flag == "YES") {
            this.applicationForm_data = res.data.applicationForm_data;
            this.all_app_form_data = res.data.all_app_form_data;
            this.serial_track = res.data.serial_track;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    save() {
      const data = {
        ay: this.ay,
        form_no: this.form_no,
      };
      this.loader1 = true;
      axios
        .post("AdmissionForm/addNewStudent", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.smsg);
            this.onload();
            this.loader1 = false;
            return;
          }
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "New Learner Added Successfully...");
            this.onload();
            this.loader1 = false;
            // this.form_no = null
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
            this.loader1 = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader1 = false;
        })
        .finally(() => {
          // this.form_no = null
        });
    },
    onload() {
      axios
        .post("FeesStructureInstallment/getdata")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.aylist = res.data.aylist), (this.ay = res.data.curreny_ay);
            this.stud_list = res.data.stud_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
    this.org_id = localStorage.getItem("EPS-tenant");
  },
};
</script>
<style scoped>
input1 {
  width: 50%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}
input[type="number"] {
  width: 50%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}
.link {
  text-decoration: none !important;
}
@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}
.datepicker-div {
  margin-top: -20px;
}
.datepicker-div label {
  color: #00000099;
  font-size: 12px;
  position: relative;
  top: 4px;
}
.datepicker {
  border: 1px solid #dddddd;
  padding: 7px 0 7px;
  border-radius: 4px;
  width: 100%;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}

@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
}
</style>
